import { render, staticRenderFns } from "./clear-bins-from-scan.vue?vue&type=template&id=5f25e6e8&"
import script from "./js/clear-bins-from-scan.js?vue&type=script&lang=js&"
export * from "./js/clear-bins-from-scan.js?vue&type=script&lang=js&"
import style0 from "./clear-bins-from-scan.vue?vue&type=style&index=0&id=5f25e6e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports